import React, { useEffect, useState } from 'react';
import 'chartjs-adapter-luxon';
import { Chart } from 'react-chartjs-2';
import { Chart as ChartJS, BarController, Legend, LineController, LineElement, BarElement, PointElement, LinearScale, Title, Tooltip, Filler, RadialLinearScale, CategoryScale, TimeScale } from 'chart.js';
import { Colors } from 'chart.js';
import annotationPlugin from 'chartjs-plugin-annotation';

import { Empty } from 'antd'
import { ChartWrapper, ChartMaskWrapper } from './style'

ChartJS.register(annotationPlugin);
ChartJS.register(Colors);
ChartJS.register(LineController, BarController, RadialLinearScale, LineElement, BarElement, PointElement, LinearScale, CategoryScale, TimeScale, Tooltip, Filler, Title, Legend);
const SmortChart = (props) => {
    const [isShow, setIsShow] = useState(false)
    useEffect(() => {
        if(props.data!==undefined && props.data.datasets.length>0 && props.data.datasets[0].data.length>0){
            setIsShow(false)
        } else {
            setIsShow(true)
        }
    }, [props.data])

    return (
        <>
            <ChartWrapper>
                <ChartMaskWrapper className={isShow ? "Show" : "Hide"}>
                    <Empty image={Empty.PRESENTED_IMAGE_SIMPLE} />
                </ChartMaskWrapper>
                <Chart data={props.data} options={props.options} />
            </ChartWrapper>
        </>
    )
}

export default SmortChart